import axios from '../../axios.js'

export default {
  // Malaysia Peppol submission records now live in the shared submission table
  // (irsp_submission) — MY documents are built and submitted through the unified
  // gateway. A tenant is either SG or MY (mutually exclusive), so for a MY tenant
  // every /irsp-submissions row is a Malaysia submission; no country filter needed.
  // GET /irsp-submissions — nestjsx/crud list; array in body + pagination headers.
  fetchRecords({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/irsp-submissions', { params: payload })
        .then((response) => {
          commit('SET_SUBMISSIONS', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchRecord(context, uuid) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/irsp-submissions/${uuid}?join=documents`)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
}
